<script>
    import {
        numberOfQuestions,
        maxNumberOfQuestions,
        hasQuizBegun,
        isSimulationMode,
        triviaCategories,
        schoolScore
    } from "../data/store";
    import { fly } from "svelte/transition";
    import { trivia } from "../data/trivia";
    import { get } from "svelte/store";
    import { Toaster, toast } from 'svelte-sonner';


    const onSubmit = () => {
        if(get(isSimulationMode) && get(triviaCategories).length != 2) return toast.error("You need to select 2 categories!");
        if(get(triviaCategories) == 0) return toast.error("You need to select atleast 1 category!");
        hasQuizBegun.set(true);
    };

</script>

<style>
    fieldset {
        border: 0;
        margin-top: 1em;
        padding: 0 1em;
    }
    legend {
        margin-bottom: 1em;
    }
    h1 {
        font-size: 1.8em;
        margin-bottom: 1em 0 2em 0;
    }
    label {
        color: #fff;
        cursor: pointer;
        position: relative;
        font-size: 0.8em;
        line-height: 1em;
        box-sizing: border-box;
        padding: 20px 20px 20px 64px;
        text-align: left;
        margin-bottom: 1.2em;
        width: 100%;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
    .selectable {
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }
    .checkbox {
        position: absolute;
        top: 20px;
        left: 20px;
        height: 24px;
        width: 24px;
        background-color: #fff;
        border-radius: 50%;
        transition: 0.25s all;
    }
    .checkbox:after {
        content: "";
        position: absolute;
        display: none;
    }

    .selectable:checked ~ .checkbox:after {
        display: block;
    }
    @keyframes shrinkGrow {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(0);
        }
        100% {
            transform: scale(1);
        }
    }
    .selectable:checked ~ .checkbox {
        animation-name: shrinkGrow;
        animation-duration: 0.5s;
    }

    label:hover > .checkbox {
        transform: scale(1.1);
    }
    .checkbox:after {
        top: 4px;
        left: 4px;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        background:  rgb(39,116,174)
    }

    @media only screen and (max-width: 600px) {
        .checkbox {
            top: 12px;
            left: 12px;
            height: 20px;
            width: 20px;
        }
        .checkbox:after {
            top: 4px;
            left: 4px;
            width: 12px;
            height: 12px;
        }
        label {
            padding: 14px 14px 14px 48px;
        }
    }
    
    input {
        background: transparent;
        border: 0;
        border-bottom: 2px solid #fff;
        color: #fff;
        text-align: center;
        display: block;
        margin: 0 auto;
    }
</style>

<div
    in:fly={{ x: 200, duration: 500, delay: 500 }}
    out:fly={{ x: -200, duration: 500 }}>
    <h1>Welcome to VPS preparation!</h1>
    <form on:submit|preventDefault={onSubmit}>
        <label for="simulationMode">
            <input
                class="selectable"
                type="checkbox"
                id="simulationMode"
                bind:checked={$isSimulationMode}
            />
            Simulation mode
            <span class="checkbox" />
        </label>

        <label style="display: { $isSimulationMode ? 'none' : 'block' }">
            How many questions would you like?
            <input
                type="number"
                bind:value={$numberOfQuestions}
                max={$maxNumberOfQuestions}
                min="1"
                required />
        </label>

        <label style="display: { $isSimulationMode ? 'block' : 'none' }">
            How much points you have from school?
            <input
                type="number"
                bind:value={$schoolScore}
                max="40"
                min="1"
                step="0.01"
                required />
        </label>

        <fieldset>
            <legend>Which categories would you like?</legend>
            {#each trivia as {title, data}, index }
                <label for="category{title}">
                    <input
                        class="selectable"
                        type="checkbox"
                        id="category{title}"
                        value="{data}"
                        bind:group={$triviaCategories}/>
                    <span class="checkbox" />
                    {title}
                </label>
            {/each}
        </fieldset>
        <button type="submit">Start</button>
    </form>
</div>

<Toaster richColors position="top-right" />
